import { Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import { UserProvider, useUser } from './contexts/UserContext';
import { BrainIndexingProvider } from './contexts/BrainIndexingContext';
import { LocaleProvider } from './i18n';
import { antdTheme, appBackground } from './theme';
import LoginPage from './components/LoginPage';
import AgentListPage from './components/AgentListPage';
import BuilderPage from './components/BuilderPage';
import MarketplacePage from './components/MarketplacePage';
import MeetingDoubtsPage from './components/MeetingDoubtsPage';
import UsersPage from './components/UsersPage';
import DocsPage from './components/DocsPage';
import ApiDocsPage from './components/ApiDocsPage';
import BrainPage from './components/BrainPage';
import RoadmapPage from './components/RoadmapPage';
import BusinessCasePage from './components/BusinessCasePage';
import ConnectorsPage from './components/ConnectorsPage';
import PlaygroundPage from './components/PlaygroundPage';
import OrganizationPage from './components/OrganizationPage';
import ChangelogPage from './components/ChangelogPage';
import ModelTokensPage from './components/ModelTokensPage';
import McpServersListPage from './components/McpServersListPage';
import McpServerDetailPage from './components/McpServerDetailPage';
import CognitiveAgentDetailPage from './components/CognitiveAgentDetailPage';
import AppFooter from './components/AppFooter';
import AppSidebar from './components/AppSidebar';

function AuthenticatedRoutes() {
  const { email, loading } = useUser();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!email) {
    return <LoginPage />;
  }

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: appBackground }}>
      <AppSidebar />
      <div style={{ flex: 1, minWidth: 0, height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Only this region scrolls — the footer below is a fixed sibling,
            never part of the scrolled content, so it can't end up floating
            mid-page on tall content (long Changelog, etc.). */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <Routes>
            <Route path="/" element={<AgentListPage />} />
            <Route path="/builder/new" element={<BuilderPage />} />
            <Route path="/builder/:agentId" element={<BuilderPage />} />
            <Route path="/agents/:agentId" element={<CognitiveAgentDetailPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/marketplace/meeting-doubts" element={<MeetingDoubtsPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/api-docs" element={<ApiDocsPage />} />
            <Route path="/brain" element={<BrainPage />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/business-case" element={<BusinessCasePage />} />
            <Route path="/connectors" element={<ConnectorsPage />} />
            <Route path="/playground" element={<PlaygroundPage />} />
            <Route path="/organization" element={<OrganizationPage />} />
            <Route path="/organization/tokens" element={<ModelTokensPage />} />
            <Route path="/organization/mcp" element={<McpServersListPage />} />
            <Route path="/organization/mcp/:serverId" element={<McpServerDetailPage />} />
            <Route path="/changelog" element={<ChangelogPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <AppFooter />
      </div>
    </div>
  );
}

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <LocaleProvider>
        <UserProvider>
          <BrainIndexingProvider>
            <AuthenticatedRoutes />
          </BrainIndexingProvider>
        </UserProvider>
      </LocaleProvider>
    </ConfigProvider>
  );
}

export default App;
